<template>
  <p
    v-if="level === 'low'"
    class="body-2"
  >
    {{ name }}, thank you for completing
    the Dental Sleep Solutions questionnaire.<br>
    Based on your input, your results indicate that
    you are at low risk for sleep apnea,
    indicating a normal amount of sleepiness.
    Should any of your symptoms change,
    please let us know so we can reassess your sleepiness and
    risk for sleep apnea.<br>
    Sleep apnea is a life-threatening disease,
    and education and understanding of the condition
    is of utmost importance.<br>
    Please mention this during your visit -
    we would love to help you learn more.
  </p>
  <p
    v-else-if="level === 'moderate'"
    class="body-2"
  >
    {{ name }}, thank you for completing
    the Dental Sleep Solutions questionnaire.<br>
    Based on your input, your results indicate that
    you are at moderate risk for sleep apnea,
    indicating that some of your symptoms may be signs of
    Obstructive Sleep Apnea (OSA).
    Please talk to
    <span class="primary--text">
      Dr. {{ doctor }}
    </span>
    or any of our staff to find out about our advanced tools for
    diagnosing sleep apnea.
    We are here to answer your questions and help you
    breathe and sleep better!<br>
    Sleep apnea is a life-threatening disease,
    and education and understanding of the condition
    is of utmost importance.<br>
    Please mention this during your visit -
    we would love to help you learn more.
  </p>
  <p
    v-else-if="level === 'high'"
    class="body-2"
  >
    {{ name }}, thank you for completing
    the Dental Sleep Solutions questionnaire.<br>
    Based on your input, your results indicate that
    you are at high risk for sleep apnea, indicating that
    your symptoms are likely signs of
    Obstructive Sleep Apnea (OSA) and excessive sleepiness,
    and medical attention should be sought.
    Please talk to
    <span class="primary--text">
      Dr. {{ doctor }}
    </span>
    or any of our staff to find out about our advanced tools for
    diagnosing sleep apnea.<br>
    Sleep apnea is a life-threatening disease.
    Please mention this during your visit -
    we would love to help you learn more.
    Due to your HIGH risk of sleep apnea,
    it is IMPORTANT that you discuss sleep apnea and treatment options
    with us. We're here to help!
  </p>
  <p
    v-else
    class="body-2"
  >
    {{ name }}, thank you for completing
    the Dental Sleep Solutions questionnaire.<br>
    Based on your input, your results indicate that
    you are at severe risk for sleep apnea, indicating that
    your symptoms are likely signs of
    Obstructive Sleep Apnea (OSA) and excessive sleepiness
    and medical attention should be sought.
    Please talk to
    <span class="primary--text">
      Dr. {{ doctor }}
    </span>
    or any of our staff to find out about our advanced tools for
    diagnosing sleep apnea.<br>
    Sleep apnea is a life-threatening disease.
    Please mention this during your visit -
    we would love to help you learn more.
    Due to your SEVERE risk of sleep apnea,
    it is IMPORTANT that you discuss sleep apnea and treatment options
    with us. We're here to help!
  </p>
</template>

<script>
export default {
  props: {
    level: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    doctor: {
      type: String,
      required: true
    }
  }
}
</script>
